import React, {useState} from "react";
import {
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  Button,
  Spinner,
  Col,
  Input,
  Row,
  FormGroup,
  Label
} from "reactstrap";
import LaddaButton, {EXPAND_RIGHT} from "react-ladda";
import PropTypes from "prop-types";
import {FormField, SelectFormField} from "../../../utils/FormFields";
import {BankAccountType, BankAccountStatus} from "../Account/types";

function ModalBankAccount({
  open,
  bankAccount,
  errors,
  toggle,
  saving,
  onSave,
  onChange,
  currencies,
  banks,
  archives,
  setArchives,
  getFile
}) {
  const deleteArchive=(id)=>{
    var archivesAux = [...archives]; 
  
    if (id !== -1) {
      archivesAux.splice(id, 1);
    }

    setArchives(
      archivesAux
    );

  }

  const handleFile = (file, name, extension) => {
    const items = file.split(',');
    var archive={ ArchiveId:0, ArchiveBlob: items[1],
      ArchiveExtension: extension,
      ArchiveName: name}
    setArchives([...archives, archive]);
  };

  const handleFileInput = (event, cb = handleFile) => {
    const file = event.target.files[0];
    const name = (file.name).substring(0, file.name.indexOf('.'));
    if (file.size <= 5242880){
      const extension = (file.name).substring(file.name.indexOf('.') + 1, file.name.length);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        cb(reader.result, name, extension);
      };
      reader.onerror = (error) => {
        throw error;
      };
    }else {
      alert("File is too big! (Max. 5MB)");
      event.target = "";
    }
  };

  return (
    <Modal isOpen={open} toggle={toggle}>
      <ModalHeader toggle={toggle}>Bank Account</ModalHeader>
      <ModalBody>
        <Form>
          {banks ? (
            <SelectFormField
              label="Bank: "
              name="PersonBankAccountBankId"
              onChange={onChange}
              value={bankAccount.PersonBankAccountBankId}
              selectItems={[{Id: "", Name: ""}].concat(banks)}
              getSelectItemId={i => i.Id}
              getSelectItemName={i => i.Name}
            />
          ) : (
            <Spinner size="sm" />
          )}
          <FormField
            label="Personal Name: "
            name="PersonBankAccountPersonalName"
            onChange={onChange}
            value={bankAccount.PersonBankAccountPersonalName}
          />
          <FormField
            label="Holders: "
            name="PersonBankAccountHolders"
            onChange={onChange}
            value={bankAccount.PersonBankAccountHolders}
          />
          <FormField
            label="Branch: "
            name="PersonBankAccountBranch"
            onChange={onChange}
            value={bankAccount.PersonBankAccountBranch}
            type="number"
            dataTypeDecimalName="currency"
          />
          <SelectFormField
            label="Type: "
            name="PersonBankAccountType"
            value={bankAccount.PersonBankAccountType}
            onChange={onChange}
            selectItems={Object.keys(BankAccountType)}
            getSelectItemId={i => i}
            getSelectItemName={i => BankAccountType[i]}
          />
          <FormField
            label="Number: "
            name="PersonBankAccountNumber"
            onChange={onChange}
            value={bankAccount.PersonBankAccountNumber}
          />
          {currencies ? (
            <SelectFormField
              label="Currency: "
              name="PersonBankAccountCurrency"
              onChange={onChange}
              value={bankAccount.PersonBankAccountCurrency}
              selectItems={currencies}
              getSelectItemId={i => i.currencyId}
              getSelectItemName={i => i.currencyISO}
            />
          ) : (
            <Spinner size="sm" />
          )}
          <SelectFormField
            label="Default Permanent Instruction: "
            name="PersonBankAccountIsDepositInterest"
            onChange={onChange}
            value={bankAccount.PersonBankAccountIsDepositInterest}
            selectItems={[false, true]}
            getSelectItemId={i => i}
            getSelectItemName={i => (i ? "Yes" : "No")}
          />
          <SelectFormField
            label="Fund Incomes only: "
            name="PersonBankAccountFundIncomesOnly"
            onChange={onChange}
            value={bankAccount.PersonBankAccountFundIncomesOnly}
            selectItems={[false, true]}
            getSelectItemId={i => i}
            getSelectItemName={i => (i ? "Yes" : "No")}
          />
          <FormField
            label="Observation: "
            name="PersonBankAccountObs"
            type="textarea"
            value={bankAccount.PersonBankAccountObs}
            onChange={onChange}
          />
          <SelectFormField
            label="Status: "
            name="PersonBankAccountStatus"
            value={bankAccount.PersonBankAccountStatus}
            onChange={onChange}
            selectItems={Object.keys(BankAccountStatus)}
            getSelectItemId={i => i}
            getSelectItemName={i => BankAccountStatus[i]}
          />

          <Row>
            <Col>
              <Input
                type="file"
                datamaxsize="2048"
                accept="image/jpeg,image/gif,image/png,application/pdf"
                onChange={handleFileInput}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <ListArchives archives={archives} deleteArchive={deleteArchive} getFile={getFile}/>
            </Col>
          </Row>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
        <LaddaButton
          className="btn btn-ladda btn-primary"
          loading={saving}
          onClick={onSave}
          data-style={EXPAND_RIGHT}
        >
          {saving ? " Saving" : " Save"}
        </LaddaButton>
      </ModalFooter>
    </Modal>
  );
}

const ListArchives = ({archives, deleteArchive, getFile}) => {
  return (
    <FormGroup className="mb-4">
      {archives &&
        (archives.length == 0 ? (
          <div
            style={{
              padding: "10px",
              paddingLeft: "2px",
              marginTop: "8px",
              color: "var(--gray-400)"
            }}
          >
            <span className="h6" style={{textAlign: "center"}}>No Attachments</span>
          </div>
        ) : (
          <div className="attachments">
            {archives.map((item, index) => (
              <Line index={index} file={item} deleteArchive={deleteArchive} getFile={getFile}/>
            ))}
          </div>
        ))}
    </FormGroup>
  );
};

const Line = ({index, file, deleteArchive, getFile}) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      padding: "0px 7px",
      borderRadius: "5px"
    }}
  >
    <a
      onClick={() => getFile(file)} style = {{cursor:'pointer'}}
      /*href={`data:application/octet-stream;base64,${file.ArchiveBlob}`}
      download={`${file.ArchiveName}.${file.ArchiveExtension}`}*/
      deleteArchive={deleteArchive}
      archiveId={file.ArchiveId}
    >
      {`${file.ArchiveName}.${file.ArchiveExtension}`}
    </a>
    {"  "}
    <Button
      color="btn-outline-primary btn-sm"
      onClick={() => deleteArchive(index)}
      style={{color: "#d83737"}}
    >
      <i className="fa fa-trash" />
    </Button>
  </div>
);

ModalBankAccount.propTypes = {
  open: PropTypes.bool.isRequired,
  bankAccount: PropTypes.object.isRequired,
  toggle: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  currencies: PropTypes.array,
  banks: PropTypes.array
};

ModalBankAccount.defaultProps = {
  banks: undefined,
  currencies: undefined
};

export default ModalBankAccount;
